export default __webpack_public_path__ + "static/media/portfolio.f6deac5a.png";